import gsap from 'gsap';

function FollowButton({ node }) {
	const options = node.dataset.options
		? JSON.parse(node.dataset.options)
		: {
				movement: 1,
		  };

	// const combinedOptions = { ...defaultOptions, ...options };

	var mWrap = node.querySelectorAll('.js-follow-btn');

	function parallaxIt(e, wrap, movement = 1) {
		var scrollTop = window.scrollY || document.documentElement.scrollTop;
		var boundingRect = wrap.area.getBoundingClientRect();
		var halfDiff = Math.abs(boundingRect.width - boundingRect.height) / 2;
		var relX = e.pageX - boundingRect.left - halfDiff;
		var relY = e.pageY - boundingRect.top;

		gsap.to(wrap.content, {
			x: (relX - boundingRect.width / 2) * movement,
			y: (relY - boundingRect.height / 2 - scrollTop) * movement,
			ease: 'power1',
			duration: 0.6,
		});

		// gsap.to(wrap.text, {
		// 	x: (relX - boundingRect.width / 2) * movement * 0.5,
		// 	y: (relY - boundingRect.height / 2 - scrollTop) * movement * 0.5,
		// 	ease: 'power1',
		// 	duration: 0.3,
		// });
	}

	mWrap.forEach(function (wrap) {
		wrap.content = wrap.querySelector('.js-follow-btn-content');
		wrap.area = wrap.querySelector('.js-follow-btn-area');
		// wrap.text = wrap.querySelector('.js-follow-btn-text');

		wrap.area.addEventListener('mousemove', function (e) {
			parallaxIt(e, wrap, options?.movement || 1);
		});

		wrap.area.addEventListener('mouseleave', function (e) {
			gsap.to(wrap.content, {
				scale: 1,
				x: 0,
				y: 0,
				ease: 'power3',
				duration: 0.6,
			});

			// gsap.to(wrap.text, {
			// 	scale: 1,
			// 	x: 0,
			// 	y: 0,
			// 	ease: 'power3',
			// 	duration: 0.6,
			// });
		});
	});
}

export default FollowButton;
